import { Button } from 'react-bootstrap';
import { formatFileSize } from 'src/services/formatFileSize';
import getFileIcon from 'src/services/getFileIcon';
import getFileType from 'src/services/getFileType';

const Attachment = ({ item, onDelete, title }) => {
  const isAttachment = item.attachmentTypeId === 1;
  const fileType = getFileType(title);

  const Icon = getFileIcon(fileType, { marginRight: '0.625rem' }, '2rem');

  return (
    <div className="flex border items-center justify-between p-3 m-2 rounded-md">
      <div className="flex items-center -ml-1">
        <Icon />
        <span data-cy="filename">{title}</span>
      </div>
      {isAttachment && (
        <div className="flex items-center">
          <small>{formatFileSize(item.size)}</small>
        </div>
      )}
      <div className="flex items-center">
        <Button
          variant="link"
          className="ms-auto text-decoration-none text-danger"
          onClick={onDelete}
          data-cy={isAttachment ? 'delete-attachment-button' : 'delete-link-button'}
        >
          X
        </Button>
      </div>
    </div>
  );
};

export default Attachment;
